// extracted by mini-css-extract-plugin
export var callCard = "_sj-0";
export var callMessageButton = "_sj-1";
export var helpIcon = "_sj-3";
export var helpIconContainer = "_sj-4";
export var verticalDivider = "_sj-2";